import React from "react";
import Button from "@mui/material/Button";

export const ButtonField = ({
  title,
  onClick,
  id,
  disabled = false,
  variant = "contained",
  color = "primary",
  type = "button",
  size = "medium",
  startIcon,
  endIcon,
  sx,
}: IButton) => {
  return (
    <Button
      id={id}
      sx={sx}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      color={color}
      size={size}
      type={type}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {title}
    </Button>
  );
};
export interface IButton {
  title?: string | React.ReactNode;
  onClick?: any;
  type?: "submit" | "button" | "reset";
  id?: string;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
  variant?: "text" | "contained" | "outlined";
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  sx?: any;
}
